import { request } from './client';

export const demoApi = {
	start: (programId?: number): Promise<{ url: string }> =>
		request<{ url: string }>('/demo/start', {
			method: 'POST',
			data: { program_id: programId },
		}),
};
